import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#464646",
      "clip-path": "url(#clip0_hide_password)",
      transform: "translate(0 3.5)"
    }, [
      _createElementVNode("path", { d: "M4.57 3.466c-2.007 1.28-3.29 2.888-3.29 3.387 0 1.032 3.901 5.116 8.724 5.116a9.1 9.1 0 0 0 2.667-.411l.948.947a10.8 10.8 0 0 1-3.615.62C4.164 13.125 0 8.346 0 6.853c0-.862 1.377-2.803 3.659-4.296zM20 6.853c0 .835-1.276 2.696-3.436 4.175l-.895-.894c1.867-1.224 3.05-2.714 3.05-3.28 0-.872-3.915-5.116-8.715-5.116-.83 0-1.633.126-2.39.345l-.963-.961c1.03-.34 2.156-.54 3.353-.54C15.909.582 20 5.353 20 6.853m-8.31 3.726a4.11 4.11 0 0 1-5.8-3.74c.001-.602.13-1.174.367-1.687zm2.42-3.74c0 .516-.096 1.01-.274 1.463L8.538 3.007a4.104 4.104 0 0 1 5.571 3.832M15.719 13.19c.227.228.57.242.798 0a.54.54 0 0 0 0-.797L4.28.165a.574.574 0 0 0-.805 0 .58.58 0 0 0 0 .797z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_hide_password" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }